{
  "app": {
    "title": "EddanRPG Kartor",
    "subtitle": "Teamets kartverktyg — zoner, platser, spawns och uppdrag i Unity-koordinater",
    "noMaps": "Inga kartor än"
  },
  "common": {
    "save": "Spara",
    "cancel": "Avbryt",
    "delete": "Ta bort",
    "close": "Stäng",
    "apply": "Verkställ",
    "add": "Lägg till",
    "reset": "Återställ",
    "loading": "Laddar…",
    "copied": "Kopierat",
    "name": "Namn",
    "key": "Nyckel",
    "description": "Beskrivning",
    "tags": "Taggar",
    "all": "alla",
    "none": "inga",
    "someone": "någon"
  },
  "roles": {
    "admin": "Admin",
    "editor": "Redaktör",
    "viewer": "Läsare"
  },
  "login": {
    "email": "E-post",
    "password": "Lösenord",
    "submit": "Logga in",
    "failed": "Inloggningen misslyckades",
    "hint": "Konton skapas av en admin. Fråga Niklas om du behöver ett."
  },
  "top": {
    "map": "Karta",
    "searchPlaceholder": "Sök på namn, nyckel eller tagg — eller klistra in koordinater",
    "jumpTo": "Gå till X {{x}}, Z {{z}}",
    "noResults": "Inget hittades",
    "language": "Språk",
    "logout": "Logga ut",
    "realtime": {
      "connecting": "Ansluter…",
      "connected": "Live — andras ändringar syns direkt",
      "offline": "Frånkopplad — återansluter"
    },
    "views": {
      "map": "Karta",
      "data": "Speldata"
    }
  },
  "left": {
    "draw": "Rita",
    "tools": "Verktyg",
    "layers": "Lager",
    "noBaseLayers": "Inga kartbilder än. En admin kan ladda upp under Admin → Lager.",
    "opacity": "Opacitet",
    "overlays": "Överlägg",
    "filters": "Filter",
    "featureTypes": "Typer",
    "statuses": "Status",
    "onlyMine": "Bara sådant jag skapat",
    "tagFilter": "Filtrera på tagg",
    "queue": "Att bygga i Unity",
    "queueEmpty": "Inget väntar på Unity"
  },
  "overlays": {
    "chunkGrid": "Chunk-rutnät (scennamn)",
    "grid100": "100 m-rutnät",
    "asBuilt": "Konturer från Unity",
    "labels": "Etiketter",
    "questRoutes": "Uppdragsrutter"
  },
  "tools": {
    "measure": "Mät",
    "pick": "Hämta koordinat",
    "measureHint": "Klicka för att mäta en sträcka. Esc rensar.",
    "measureValue": "{{length}} m — area för den slutna formen {{area}} m² — Esc rensar",
    "pickHint": "Klicka på kartan för att kopiera en Unity Vector3",
    "copiedValue": "Kopierade {{value}}",
    "editHint": "Dra i hörnen för att ändra formen, dra formen för att flytta. Sparas automatiskt. Esc när du är klar.",
    "drawHint": {
      "point": "Klicka för att placera. Esc avbryter.",
      "circle": "Klicka i mitten och sedan igen för radien. Esc avbryter.",
      "rect": "Klicka i ett hörn och sedan i motsatt hörn. Esc avbryter.",
      "polygon": "Klicka för att lägga till hörn, klicka på första hörnet för att avsluta. Esc avbryter.",
      "polyline": "Klicka för att lägga till punkter, klicka på sista punkten igen för att avsluta. Esc avbryter."
    }
  },
  "groups": {
    "areas": "Områden",
    "places": "Platser",
    "characters": "Karaktärer",
    "mobs": "Monster",
    "quests": "Uppdrag",
    "objects": "Objekt",
    "annotations": "Anteckningar & vägar"
  },
  "types": {
    "zone": "Zon",
    "mob_spawn_area": "Spawnområde",
    "mob_spawn_point": "Spawnpunkt",
    "npc": "NPC",
    "poi": "Intressant plats",
    "quest": "Uppdrag",
    "quest_step": "Uppdragssteg",
    "quest_location": "Uppdragsutlösare",
    "resource_node": "Resurs / ört",
    "altar": "Altare",
    "loot_container": "Kista / behållare",
    "interactable": "Interaktivt objekt",
    "respawn_point": "Återuppståndelsepunkt",
    "player_start": "Spelarstart",
    "patrol_area": "Patrullområde",
    "path": "Väg",
    "note": "Anteckning"
  },
  "presets": {
    "village": "By / stad",
    "forest": "Skog",
    "meadows": "Äng",
    "lake": "Sjö",
    "coastal": "Kust",
    "landmark": "Landmärke",
    "dungeon": "Grotta / dungeon",
    "npc": "NPC",
    "mob_area": "Spawnområde",
    "mob_point": "Spawnpunkt",
    "quest": "Uppdrag",
    "quest_step": "Uppdragssteg",
    "quest_area": "Uppdragsutlösare",
    "herb_patch": "Örtsamling",
    "resource": "Resurs",
    "altar": "Altare",
    "chest": "Kista",
    "interactable": "Interaktivt objekt",
    "respawn": "Återuppståndelse",
    "player_start": "Spelarstart",
    "patrol_area": "Patrullområde",
    "road": "Väg",
    "river": "Å / flod",
    "note": "Anteckning",
    "note_area": "Anteckningsområde"
  },
  "status": {
    "idea": "Idé",
    "proposed": "Förslag",
    "approved": "Godkänd",
    "in_unity": "I Unity",
    "needs_update": "Behöver uppdateras",
    "deprecated": "Utfasad"
  },
  "sync": {
    "unlinked": "Ej kopplad",
    "in_sync": "Stämmer med Unity",
    "design_ahead": "Designen ändrad",
    "unity_ahead": "Unity ändrat",
    "conflict": "Konflikt",
    "missing_in_unity": "Saknas i Unity"
  },
  "inspector": {
    "tabs": {
      "properties": "Egenskaper",
      "geometry": "Form",
      "unity": "Unity",
      "comments": "Kommentarer",
      "history": "Historik"
    },
    "to": {
      "idea": "Tillbaka till idé",
      "proposed": "Föreslå",
      "approved": "Godkänn",
      "in_unity": "Markera som i Unity",
      "needs_update": "Behöver uppdateras",
      "deprecated": "Fasa ut"
    },
    "setStatus": "Sätt status…",
    "statusAuto": "Sparat — status är nu ”{{status}}”",
    "zoomTo": "Zooma hit",
    "editShape": "Ändra form",
    "doneEditing": "Klar",
    "copyLink": "Kopiera länk",
    "confirmDelete": "Ta bort ”{{name}}”? Det går inte att ångra.",
    "removeGone": "Ta bort från verktyget",
    "confirmRemoveGone": "Ta bort ”{{name}}” från verktyget? Den finns inte längre i Unity. Kommentarerna försvinner med den; historiken sparar en notering. Om den kommer tillbaka i Unity läggs den till som ny vid nästa import.",
    "conflict": "{{name}} ändrade detta medan du redigerade.",
    "reloadTheirs": "Hämta deras version",
    "applyMine": "Lägg min ändring ovanpå",
    "keyLocked": "låst — finns i Unity",
    "keyFromName": "Skapa nyckel från namnet",
    "parent": "Tillhör",
    "showInGame": "Visa på kartan i spelet",
    "color": "Färg",
    "tagsHint": "kommaseparerade",
    "unsaved": "Osparade ändringar",
    "designOnly": "design",
    "attachments": "Bilder & filer",
    "addFiles": "Lägg till bilder eller filer",
    "createdBy": "Skapad av {{name}}",
    "updatedBy": "senast ändrad av {{name}}"
  },
  "props": {
    "zoneId": "Zon-id",
    "zoneType": "Zontyp",
    "priority": "Prioritet",
    "exitMargin": "Utgångsmarginal (m)",
    "unrevealedName": "Namn innan upptäckt",
    "bannerSubtitle": "Banderollens underrubrik",
    "bannerColor": "Banderollfärg",
    "lightingProfile": "Ljusprofil",
    "revealAfterQuest": "Visas efter uppdrag",
    "linkedSpawnZone": "Kopplat spawnområde",
    "levelMin": "Nivå från",
    "levelMax": "Nivå till",
    "mood": "Stämning & utseende",
    "mode": "Spawnläge",
    "randomSpawns": "Monster",
    "mob": "Monster-prefab",
    "weight": "Vikt",
    "maxCount": "Max",
    "respawnTime": "Återkomst (s)",
    "cellSize": "Cellstorlek (m)",
    "cellSpawnChance": "Cellchans",
    "maxPerCell": "Max per cell",
    "activationRadius": "Aktiveringsradie (m)",
    "despawnRadius": "Despawnradie (m)",
    "wanderRadius": "Vandringsradie (m)",
    "exclusionZones": "Undantagna zoner",
    "density": "Täthet",
    "movement": "Rörelse",
    "patrolPath": "Patrullrutt",
    "actorId": "Aktörs-id",
    "title": "Titel",
    "prefab": "Prefab",
    "roles": "Roller",
    "merchantId": "Handlar-id",
    "trainerId": "Tränar-id",
    "recipeTrainerId": "Recepttränar-id",
    "factionId": "Fraktion",
    "patrolArea": "Patrullområde",
    "patrolRadius": "Patrullradie (m)",
    "personality": "Personlighet & historia",
    "poiId": "POI-id",
    "poiType": "POI-typ",
    "markerColor": "Markörfärg",
    "showLabel": "Visa etikett",
    "icon": "Ikon-id",
    "questID": "Uppdrags-id",
    "category": "Kategori",
    "requiredLevel": "Krävd nivå",
    "giverNpc": "Uppdragsgivare",
    "turnInNpc": "Lämnas in till",
    "mapZone": "Kartzon",
    "mapPoi": "Kart-POI",
    "repeatable": "Kan upprepas",
    "prerequisites": "Krävda uppdrag",
    "rewardsIdea": "Belöningsidéer",
    "stepIndex": "Stegnummer",
    "objectiveType": "Mål",
    "target": "Mål-id",
    "requiredCount": "Antal",
    "optional": "Valfritt",
    "location": "Plats",
    "locationTag": "Platstagg",
    "destroyOnEnter": "Ta bort utlösaren när man gått in",
    "height": "Utlösarens höjd (m)",
    "spawnTargetId": "Mål-id",
    "spawnPrefab": "Spawn-prefab",
    "harvestTypeId": "Skördetyp",
    "note": "Anteckning",
    "count": "Hur många",
    "lootIdea": "Idéer om byte",
    "purpose": "Sort",
    "width": "Bredd (m)"
  },
  "enums": {
    "zoneType": {
      "Village": "By",
      "Forest": "Skog",
      "Lake": "Sjö",
      "Meadows": "Äng",
      "Coastal": "Kust"
    },
    "mode": {
      "Random": "Slumpad (fröade celler)",
      "Defined": "Bestämda spawnpunkter"
    },
    "density": {
      "sparse": "Glest",
      "normal": "Normalt",
      "dense": "Tätt"
    },
    "movement": {
      "Wander": "Vandrar",
      "Waypoints": "Följer rutt"
    },
    "roles": {
      "QuestGiver": "Uppdragsgivare",
      "Merchant": "Handlare",
      "Trainer": "Tränare",
      "RecipeTrainer": "Recepttränare",
      "Dialogue": "Dialog",
      "SequenceActor": "Mellansekvensaktör"
    },
    "poiType": {
      "Landmark": "Landmärke",
      "Merchant": "Handlare",
      "SpawnPoint": "Startpunkt",
      "Home": "Hem",
      "QuestGiver": "Uppdragsgivare",
      "Dungeon": "Dungeon"
    },
    "objectiveType": {
      "Kill": "Döda",
      "Collect": "Samla",
      "UseItem": "Använd föremål",
      "Produce": "Tillverka",
      "TalkToNPC": "Prata med NPC",
      "Escort": "Eskortera",
      "GoToLocation": "Gå till plats",
      "CustomEvent": "Egen händelse",
      "Harvest": "Skörda"
    },
    "purpose": {
      "road": "Väg",
      "trail": "Stig",
      "river": "Å / flod",
      "patrol": "Patrullrutt",
      "quest_route": "Uppdragsrutt"
    }
  },
  "geometry": {
    "kind": "Form",
    "kinds": {
      "point": "Punkt",
      "circle": "Cirkel",
      "rect": "Rektangel",
      "polygon": "Polygon",
      "polyline": "Linje",
      "none": "Ingen form"
    },
    "position": "Position",
    "center": "Mittpunkt",
    "chunk": "Chunk-scen",
    "area": "Area",
    "perimeter": "Omkrets",
    "length": "Längd",
    "vertices": "Hörn",
    "yUnknown": "Höjden (Y) är okänd tills en höjdkarta importerats — Unity placerar mot marken.",
    "copyVector3": "Kopiera Vector3 (Inspector)",
    "copyCSharp": "Kopiera C# Vector3",
    "copyPoints": "Kopiera punkter som JSON",
    "fields": {
      "x": "X",
      "z": "Z",
      "rotY": "Rotation Y°",
      "r": "Radie",
      "w": "Bredd (X)",
      "d": "Djup (Z)"
    }
  },
  "unity": {
    "designOnlyType": "Anteckningar är bara design och går aldrig till Unity.",
    "asset": "ScriptableObject-asset",
    "component": "Komponent",
    "scene": "Scen",
    "idField": "Unity-id ({{field}})",
    "link": "Koppling",
    "hierarchy": "Hierarki",
    "unityPosition": "I Unity",
    "geometry": "Form",
    "design": "Design",
    "takeUnity": "Använd Unitys version",
    "keepDesign": "Behåll designen (Unity ska ändras)",
    "unlink": "Koppla bort",
    "confirmUnlink": "Glöm kopplingen till Unity-objektet? Objektet finns kvar här; nästa import kan skapa det på nytt.",
    "explain": {
      "unlinked": "Inte kopplad till något i Unity än. Godkänn, bygg i Unity och importera sedan från Unity (eller markera som i Unity).",
      "in_sync": "Designen och Unity stämmer överens.",
      "design_ahead": "Designen har ändrats efter att den byggts. Unity behöver uppdateras.",
      "unity_ahead": "Unity har ändrats men inte designen. Nästa import uppdaterar designen.",
      "conflict": "Både designen och Unity har ändrats. En admin måste välja vilken version som gäller.",
      "missing_in_unity": "Det kopplade objektet fanns inte i senaste Unity-exporten — borttaget eller omdöpt?"
    }
  },
  "comments": {
    "empty": "Inga kommentarer än.",
    "placeholder": "Skriv en kommentar…",
    "post": "Skicka",
    "ctrlEnter": "Ctrl+Enter skickar",
    "resolve": "Markera löst",
    "reopen": "Öppna igen",
    "confirmDelete": "Ta bort kommentaren?",
    "showResolved": "Visa {{count}} lösta",
    "hideResolved": "Dölj lösta"
  },
  "history": {
    "empty": "Ingen historik än.",
    "restore": "Återställ den här versionen",
    "confirmRestore": "Återställ innehållet som det var {{date}}? Status och nyckel ändras inte.",
    "system": "Systemet",
    "actions": {
      "create": "Skapad",
      "update": "Ändrad",
      "delete": "Borttagen",
      "status": "Status",
      "import": "Unity-import",
      "restore": "Återställd",
      "rekey": "Ny nyckel"
    },
    "fields": {
      "type": "typ",
      "key": "nyckel",
      "name": "namn",
      "description": "beskrivning",
      "geometry": "form",
      "properties": "egenskaper",
      "designProps": "designanteckningar",
      "status": "status",
      "showInGame": "spelkartan",
      "parent": "tillhör",
      "tags": "taggar",
      "color": "färg",
      "sortOrder": "ordning",
      "unityKey": "Unity-koppling"
    }
  },
  "admin": {
    "title": "Admin",
    "tabs": {
      "layers": "Lager",
      "import": "Importera från Unity",
      "export": "Exportera",
      "users": "Användare",
      "gamedata": "Importera speldata",
      "fields": "Fält",
      "dataexport": "Exportera till Unity"
    },
    "layers": {
      "empty": "Inga baslager än.",
      "exact": "Exakt placering (Unity-rendering)",
      "fitted": "Kalibrerad med {{n}} punkter, fel {{rms}} m",
      "uncalibrated": "Inte kalibrerad — utsträckt över hela världen",
      "visibleByDefault": "Synlig från start",
      "up": "Rita ovanför",
      "down": "Rita under",
      "calibrate": "Kalibrera",
      "confirmDelete": "Ta bort lagret ”{{name}}”?",
      "upload": "Ladda upp en kartbild",
      "source": "Källa",
      "sources": {
        "unity_render": "Unity-rendering",
        "painted": "Målad karta",
        "sketch": "Skiss",
        "other": "Annat"
      },
      "presetFound": "Känns igen som Startlands målade karta — placeras med den uppmätta passningen.",
      "stretchNote": "Den sträcks först ut över hela världen; kalibrera den efteråt.",
      "uploadButton": "Ladda upp",
      "uploaded": "Lagret är uppladdat",
      "notAnImage": "Filen kan inte läsas som en bild"
    },
    "import": {
      "help": "Kör EnyaRPG → World → Maps Editor → Export Startland i Unity och välj filerna från Builds/MapsEditorExport/…. Kontrollera först, verkställ sedan.",
      "render": "Rendering ovanifrån",
      "heights": "Höjdkarta",
      "badJson": "Filen är inte giltig JSON",
      "dirty": "ocommittade ändringar",
      "wrongWorld": "Exporten gäller {{got}}, men den öppna kartan är {{want}}.",
      "fastForward": "Uppdatera sådant som bara ändrats i Unity",
      "dryRun": "Kontrollera (provkörning)",
      "apply": "Verkställ import",
      "planTitle": "Det här gör importen",
      "resultTitle": "Importen är klar",
      "renderLayerName": "Unity ovanifrån",
      "done": "Importen är verkställd",
      "warnings": "Varningar",
      "counts": {
        "objects": "Objekt i exporten",
        "adopted": "Nya (övertagna)",
        "linked": "Nyss kopplade",
        "inSync": "Stämmer redan",
        "fastForwarded": "Uppdaterade från Unity",
        "designAhead": "Designen ändrad (behöver uppdateras)",
        "conflicts": "Konflikter",
        "missing": "Saknas i Unity",
        "skipped": "Hoppades över"
      },
      "actions": {
        "adopted": "ny",
        "in_sync": "kopplad",
        "design_ahead": "designen före",
        "fast_forwarded": "uppdaterad",
        "unity_ahead": "Unity före",
        "conflict": "konflikt",
        "missing_in_unity": "saknas"
      }
    },
    "export": {
      "help": "Exporter använder Unitys världsmeter (X öster, Z norr) och stabila nycklar.",
      "full": "Ladda ner full export",
      "fullHelp": "Allt, med Unity-koppling och synkstatus — underlag för den framtida Unity-importen.",
      "ingame": "Ladda ner export till spelkartan",
      "ingameHelp": "Bara godkända zoner och platser som ska visas på kartan i spelet.",
      "snapshot": "Ögonblicksbild i git",
      "snapshotHelp": "Skriver data/<karta>/export.json och export.ingame.json för granskning och commit."
    },
    "users": {
      "resetPassword": "Nytt lösenord",
      "confirmReset": "Sätta ett nytt lösenord för {{name}}?\n\n{{password}}\n\nDet kopieras till urklipp.",
      "passwordCopied": "Nytt lösenord kopierat — skicka det privat",
      "new": "Nytt konto",
      "role": "Roll",
      "passwordHint": "E-post och lösenord kopieras till urklipp när kontot skapas.",
      "create": "Skapa konto",
      "created": "Kontot är skapat — inloggningsuppgifterna är kopierade"
    },
    "gamedata": {
      "help": "Kör EnyaRPG → World → Maps Editor → Export game data i Unity efter varje release. Välj unity-data.json och alla PNG-filer i mappen icons under Builds/MapsEditorExport/gamedata/…. Kontrollera först, verkställ sedan.",
      "badFile": "Filen är inte en speldata-export (unity-data.json)",
      "done": "Speldatan är importerad",
      "icons": "Ikoner (markera alla PNG-filer i mappen icons)",
      "summary": "{{assets}} objekt, {{icons}} ikoner",
      "iconsMatched": "{{matched}} av {{total}} ikoner finns bland de valda filerna",
      "iconProgress": "Laddar upp ikoner: {{done}} av {{total}}",
      "initial": "Första importen: alla fält får standardinställningar. Justera vad designerna ser under Fält.",
      "schemaTitle": "Ändringar i Unity-koden",
      "classAdded": "Ny klass: {{name}}",
      "classRemoved": "Klassen {{name}} finns inte längre",
      "fieldAdded": "Nytt fält {{owner}}.{{name}} ({{kind}})",
      "fieldRenamed": "{{owner}}.{{from}} heter nu {{to}} — värden och inställningar följer med",
      "fieldRemoved": "{{owner}}.{{name}} är borttaget",
      "fieldChanged": "{{owner}}.{{name}} har bytt typ: {{from}} → {{to}}",
      "enumChanged": "Värdelistan {{name}}: nya {{added}}, borttagna {{removed}}",
      "reviewNew": "Nya fält märks ”Nytt” under Fält tills du har granskat dem.",
      "changes": "Ändrade objekt",
      "counts": {
        "assets": "Objekt i exporten",
        "adopted": "Nya (övertagna)",
        "inSync": "Stämmer redan",
        "fastForwarded": "Uppdaterade från Unity",
        "designAhead": "Designen ändrad (behöver uppdateras)",
        "conflicts": "Konflikter",
        "missing": "Saknas i Unity",
        "skipped": "Hoppades över"
      },
      "actions": {
        "adopted": "ny",
        "in_sync": "stämmer",
        "fast_forwarded": "uppdaterad",
        "design_ahead": "designen före",
        "conflict": "konflikt",
        "missing_in_unity": "saknas",
        "linked": "kopplad"
      }
    },
    "fields": {
      "help": "Bestäm vad designerna ser av varje klass. Inställningen hör till klassen som deklarerar fältet, så Item Data gäller även mat och utrustning. Dolda fält är Unity-inställningar som bara admin ser.",
      "onlyNew": "Visa bara nya fält",
      "nested": "inbäddad",
      "newCount": "{{count}} nya",
      "markAllSeen": "Markera alla som granskade",
      "markSeen": "Granskad",
      "labels": "Etiketter och hjälptext",
      "labelSv": "Etikett (svenska)",
      "labelEn": "Etikett (engelska)",
      "helpSv": "Hjälptext (svenska)",
      "helpEn": "Hjälptext (engelska)",
      "section": "Avsnitt",
      "visibility": {
        "edit": "Redigerbart",
        "readonly": "Bara läsning",
        "hidden": "Dolt (Unity-inställning)"
      },
      "picker": "Inmatning",
      "pickers": {
        "free": "Fri text",
        "vocab": "Fri text med förslag från Unity",
        "vocab_strict": "Bara värden som redan finns i Unity",
        "auto": "Automatiskt (karta eller förslag där det passar)",
        "map_zone": "Zon på kartan (zoneId)",
        "map_poi": "Plats på kartan (poiId)",
        "map_quest_location": "Uppdragsplats på kartan (locationTag)",
        "map_npc": "NPC på kartan (namn)"
      },
      "suggest": "Föreslå synlighet ({{count}})",
      "suggestHelp": "Sätter fälten till det som reglerna föreslår i dag, t.ex. att Unity-inställningar som hideLayer eller castAnimationTrigger döljs.",
      "confirmSuggest": "Ändra synligheten för {{count}} fält enligt förslaget?"
    },
    "dataexport": {
      "help": "Godkända ändringar blir ett ändringspaket. Öppna .json-filen i Unity via EnyaRPG → World → Maps Editor → Apply change package…, och läs .md-filen för en översikt. Ändringarna blir ”I Unity” först när nästa export från Unity har importerats.",
      "nothing": "Inga godkända ändringar att skicka just nu.",
      "create": "Skapa ändringspaket ({{count}})",
      "confirm": "Skapa ett ändringspaket med {{count}} objekt? Två filer laddas ner: .json för Unity och .md att läsa.",
      "done": "Ändringspaketet är nedladdat",
      "earlier": "Tidigare paket",
      "assets": "{{count}} objekt",
      "download": "Ladda ner igen",
      "keyWarning": "byter ett namn som spelarnas sparfiler använder",
      "progressWarning": "Flyttar sparade framsteg ({{where}}): spelet sparar var spelaren är i uppdraget per stegets och målets position, så den som har uppdraget pågående hamnar på ett annat steg eller mål.",
      "comments": "{{count}} öppna kommentarer följer med",
      "added": "ny rad",
      "removed": "borttagen",
      "copyOf": "kopia av {{name}}"
    }
  },
  "calibration": {
    "title": "Kalibrera",
    "help": "Passa in bilden mot världen. Slå på Unity-renderingen under och lägg till kontrollpunkter: klicka på en plats i den här bilden, klicka sedan där platsen egentligen ligger. Två punkter räcker; med tre eller fler syns felet.",
    "addPoint": "Lägg till kontrollpunkt",
    "stopPicking": "Sluta lägga till punkter",
    "stretch": "Sträck över världen",
    "preset": "Använd uppmätt passning",
    "scaleX": "Skala X (m/px)",
    "offsetX": "Förskjutning X",
    "scaleZ": "Skala Z (m/px)",
    "offsetZ": "Förskjutning Z",
    "error": "Fel",
    "rms": "Medelfel {{rms}} m",
    "rotationWarning": "Punkterna tyder på att bilden är roterad {{deg}}° — rotation stöds inte än.",
    "save": "Spara kalibrering",
    "saved": "Kalibreringen är sparad",
    "clickImage": "Klicka på en igenkännbar plats i bilden som kalibreras",
    "clickWorld": "Klicka nu där platsen egentligen ligger (på Unity-renderingen)"
  },
  "errors": {
    "stale_revision": "Någon annan har ändrat detta under tiden.",
    "rev_required": "Appen skickade en ändring utan revision — ladda om sidan.",
    "status_transition_denied": "Bara en admin kan sätta den statusen.",
    "key_locked": "Nyckeln är låst när något finns i Unity.",
    "key_prefix": "Nyckeln måste börja med kartans prefix.",
    "geometry_invalid": "Formen är ogiltig.",
    "geometry_kind_not_allowed": "Den formen går inte för den här typen.",
    "property_invalid": "En egenskap har ett ogiltigt värde.",
    "type_invalid": "Okänd typ.",
    "type_locked": "Typen kan inte ändras när den är kopplad till Unity.",
    "map_immutable": "Ett objekt kan inte flyttas till en annan karta.",
    "parent_invalid": "Det kan inte tillhöra det.",
    "delete_denied": "Redaktörer kan bara ta bort sina egna idéer och förslag.",
    "delete_linked": "Sådant som finns i Unity fasas ut i stället för att tas bort.",
    "admin_only": "Bara admins kan göra det.",
    "role_change_denied": "Bara en admin kan ändra roller.",
    "map_not_found": "Kartan hittades inte.",
    "not_linked": "Inte kopplad till något Unity-objekt.",
    "resolve_action": "Okänd åtgärd.",
    "import_schema": "Det är ingen Unity-export från Maps Editor-exportören.",
    "import_version": "Exporten har en version som inte stöds.",
    "import_world": "Exporten gäller en annan värld.",
    "import_objects": "Exporten saknar objektlista.",
    "network": "Kan inte nå servern.",
    "unauthorized": "Sessionen har gått ut — logga in igen.",
    "rate_limited": "För många försök — vänta en stund.",
    "value_invalid": "Ogiltigt värde: {{detail}}",
    "category_readonly": "Den här kategorin går inte att redigera här än.",
    "record_deprecated": "Utfasade objekt kan inte ändras.",
    "key_required": "Namnet får inte vara tomt.",
    "key_taken": "Namnet används redan: {{detail}}",
    "not_in_unity": "Bara en import från Unity kan bekräfta att ändringen finns i Unity.",
    "export_empty": "Det finns inga godkända ändringar att skicka.",
    "comment_target": "Kommentaren saknar mål.",
    "category_missing": "Kategorin finns inte.",
    "template_missing": "Välj något i samma kategori att utgå från.",
    "asset_name_invalid": "Filnamnet får bara innehålla bokstäver, siffror, mellanslag och _ - ( ).",
    "asset_path_invalid": "Filen måste ligga under Assets/ och heta som filnamnet.",
    "asset_path_taken": "Det finns redan en fil med det namnet.",
    "record_referenced": "Något annat använder den fortfarande: {{detail}}",
    "ref_cycle": "Det skulle bli en loop: {{detail}}"
  },
  "data": {
    "title": "Speldata",
    "intro": "Spelets data från Unity: föremål, fiender, uppdrag, dialoger och mer. Föreslå ändringar, skapa nytt och skriv dialoger — Niklas godkänner och för över det till spelet.",
    "lastImport": "Senast synkad från Unity {{date}}",
    "empty": "Ingen speldata än. En admin importerar den från Unity.",
    "importNow": "Importera speldata",
    "search": "Sök i all speldata",
    "results": "{{count}} träffar",
    "filters": {
      "journalRegion": "Journalregion",
      "location": "Plats",
      "all": "Alla",
      "unset": "(ingen)",
      "clear": "Rensa filter",
      "showing": "{{shown}} av {{total}}"
    },
    "hiddenFields": "Dolda Unity-fält ({{count}}) — syns bara för admin",
    "newField": "Nytt",
    "yes": "Ja",
    "no": "Nej",
    "unityOnly": "(bara i Unity)",
    "showAll": "Visa alla {{count}}",
    "missingRef": "saknas",
    "missingBanner": "Det här fanns inte med i den senaste exporten från Unity. Det kan ha tagits bort eller flyttats.",
    "conflictBanner": "Både designen och Unity har ändrats: {{fields}}. En admin väljer vilken version som gäller.",
    "usedByNone": "Inget annat pekar hit.",
    "tabs": {
      "properties": "Egenskaper",
      "usedBy": "Används av",
      "unity": "Unity",
      "history": "Historik",
      "comments": "Kommentarer"
    },
    "unity": {
      "path": "Fil i Unity",
      "class": "Klass",
      "sync": "Synk",
      "lastImport": "Senaste import",
      "differs": "Skiljer sig från Unity",
      "design": "Design"
    },
    "categories": {
      "items": "Föremål",
      "equipment": "Utrustning",
      "mob_stats": "Fiendestatistik",
      "mobs": "Fiender",
      "loot_tables": "Loottabeller",
      "quests": "Uppdrag",
      "dialogue": "Dialoger",
      "merchants": "Handlare",
      "spells": "Besvärjelser",
      "spell_effects": "Besvärjelseeffekter",
      "altar_effects": "Altareffekter",
      "classes": "Klasser",
      "recipes": "Recept",
      "factions": "Fraktioner"
    },
    "changes": "Ändringar",
    "edit": {
      "unityHas": "I Unity:",
      "choose": "— välj —",
      "clear": "Töm",
      "up": "Flytta upp",
      "down": "Flytta ner",
      "keyLocked": "Låst: spelarnas sparfiler använder det här namnet. Bara admin kan byta det.",
      "confirmProgressMove": "Uppdraget finns i Unity. Spelet sparar var spelarna är i uppdraget per stegets och målets position, så om du flyttar eller tar bort steg eller mål hamnar den som har uppdraget pågående på fel ställe. Fortsätta?",
      "loadTheirs": "Ladda deras version",
      "mineOnTop": "Lägg mina ändringar ovanpå",
      "note": "Anteckning till Niklas",
      "notePlaceholder": "T.ex. ”behöver en ny ikon” eller varför ändringen behövs",
      "unsaved": "Osparade ändringar",
      "readOnlyCategory": "Den här kategorin går inte att redigera här än.",
      "entries": "{{count}} rader",
      "show": "visa",
      "notOnMap": "Finns inte på kartan än."
    },
    "review": {
      "to_proposed": "Markera som förslag",
      "to_idea": "Markera som idé",
      "approve": "Godkänn",
      "unapprove": "Ångra godkännandet",
      "reject": "Avvisa ändringen",
      "takeUnity": "Ta Unitys version",
      "keepDesign": "Behåll designen",
      "confirmReject": "Avvisa ändringarna i ”{{name}}”? Värdena återställs till det som finns i Unity. Historiken sparas.",
      "removeGone": "Ta bort från verktyget",
      "confirmRemoveGone": "Ta bort ”{{name}}” från verktyget? Den finns inte längre i Unity. Kommentarer och ändringar som inte skickats försvinner med den; historiken sparar en notering. Om den kommer tillbaka i Unity läggs den till som ny vid nästa import.",
      "changedBy": "Ändrad av {{name}}",
      "approvedBy": "godkänd av {{name}}",
      "exported": "skickad till Unity {{date}} — bekräftas vid nästa import"
    },
    "create": {
      "button": "Ny",
      "title": "Ny sak",
      "help": "Välj något befintligt att utgå från. Det nya blir en kopia i Unity — ikon, modell och allt som inte syns här följer med — och du ändrar det som ska vara annorlunda.",
      "template": "Utgå från",
      "key": "Namn i spelet ({{field}})",
      "assetName": "Filnamn i Unity",
      "folder": "Mapp i Unity",
      "willBe": "Skapas som",
      "create": "Skapa",
      "done": "Skapad — ändra det som ska vara annorlunda och spara",
      "newBadge": "Ny",
      "pending": "Ny: skapas i Unity som {{path}} (kopia av {{template}})",
      "confirmDelete": "Ta bort ”{{name}}”? Den finns inte i Unity än, så inget annat påverkas."
    },
    "dialogue": {
      "preview": "Förhandsvisa dialogen",
      "page": "Sida {{n}}",
      "pageOf": "Sida {{n}} av {{of}}",
      "close": "Stäng dialogen",
      "continue": "Fortsätt",
      "closed": "Stängd",
      "closedHint": "Dialogen är slut.",
      "restart": "Börja om",
      "skip": "Klicka för att visa hela texten",
      "confirmDeleteTarget": "{{count}} val på andra sidor går till sida {{n}}. Tar du bort sidan stänger de dialogen i stället. Ta bort sidan?"
    },
    "table": {
      "count": "{{count}} st",
      "filter": "Filtrera…",
      "columns": "Kolumner ({{shown}}/{{all}})",
      "help": "Klicka på en rad för att öppna den. Klicka på en rubrik för att sortera.",
      "helpEdit": "Klicka på en rad för att öppna den, på en rubrik för att sortera. Siffror och kryssrutor kan du ändra direkt här — de sparas som förslag. Markerade celler skiljer sig från Unity.",
      "status": "Status",
      "min": "Minst",
      "median": "Median",
      "max": "Störst",
      "noChanges": "Inget väntar just nu.",
      "category": "Kategori",
      "what": "Ändrat",
      "who": "Ändrat av",
      "sent": "Skickat till Unity",
      "back": "Tillbaka till {{name}}"
    },
    "sheet": {
      "viewLabel": "Vy",
      "view": {
        "table": "Tabell",
        "sheet": "Kalkylark",
        "tableHint": "En rad per post, för att balansera siffror",
        "sheetHint": "Kalkylark: en rad per steg eller sida, text ändras direkt, alla kolumner går att filtrera"
      },
      "count": "{{records}} st · {{rows}} rader",
      "search": "Sök i alla kolumner…",
      "onlyChanged": "Bara ändrade",
      "onlyChangedHint": "Rader som skiljer sig från Unity eller är nya",
      "fullText": "Hela texter",
      "fullTextHint": "Visa all text i långa celler (annars 4 rader; den markerade cellen visar alltid allt)",
      "help": "Klicka på en cell för att markera den; Shift eller att dra markerar fler. Dubbelklicka, tryck Enter eller börja skriva för att ändra — Enter sparar, Esc ångrar, Shift+Enter ger ny rad i långa texter. Ctrl+C / Ctrl+V kopierar och klistrar in mot Excel och Google Sheets. Ändringar sparas som förslag; orange celler skiljer sig från Unity och ↺ sätter tillbaka Unitys värde.",
      "helpOwn": "Svårighet och Anteckningar (kursivt) stannar i verktyget.",
      "readOnlyCategory": "Den här kategorin går inte att redigera på webben än enligt den senaste importen från Unity, så värdena går bara att läsa här. En nyare import ändrar det.",
      "ownStillEditable": "Svårighet och Anteckningar går ändå att fylla i.",
      "helpRead": "Klicka på en cell för att markera den; Shift eller att dra markerar fler, och Ctrl+C kopierar till Excel och Google Sheets. Orange celler skiljer sig från Unity.",
      "col": {
        "step": "Steg",
        "page": "Sida",
        "objectiveTypes": "Uppdragstyp",
        "factions": "Fraktion",
        "difficulty": "Svårighet",
        "notes": "Anteckningar",
        "choices": "Val",
        "status": "Status",
        "changedBy": "Ändrat av"
      },
      "options": {
        "difficulty": {
          "easy": "Lätt",
          "medium": "Medel",
          "hard": "Svår"
        }
      },
      "ownHint": "Bara i verktyget — skickas aldrig till Unity",
      "na": "N/A",
      "ends": "slut",
      "toPage": "sida {{n}}",
      "scene": "scen",
      "open": "Öppna",
      "revert": "Sätt tillbaka Unitys värde",
      "notInUnity": "Ny här — Unity har inte det här steget eller sidan än",
      "sortAsc": "Sortera A → Ö",
      "sortDesc": "Sortera Ö → A",
      "contains": "Innehåller…",
      "findValue": "Sök värde…",
      "selectAll": "Markera alla",
      "selectNone": "Avmarkera alla",
      "clearFilter": "Rensa filter",
      "filterColumn": "Sortera och filtrera {{column}}",
      "noRows": "Inga rader matchar.",
      "badValue": "”{{text}}” passar inte i {{column}}",
      "readOnly": "De här cellerna går inte att ändra här",
      "tooMany": "Klistra in högst {{max}} celler åt gången",
      "copyFailed": "Kunde inte kopiera — webbläsaren stoppade urklipp"
    }
  }
}
